module.exports = __webpack_public_path__ + "img/p-news-detail-title.7fcf1641.png";